import { useEffect, useState } from 'react';

/**
 * Devuelve `true` mientras el navegador reporte conexión y `false` cuando se
 * pierde. Se basa en `navigator.onLine` + los eventos `online`/`offline` de
 * `window`. (Es una señal optimista del navegador: "online" no garantiza que
 * el servidor responda, pero "offline" sí es fiable para avisar al usuario.)
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine
  );

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}

export default useOnlineStatus;
